import { Plugin } from 'vue'
import ElementPlus from 'element-plus'
import dayjs from 'dayjs'
import browserFirstDayOfWeek from '@/helpers/first-day-of-week'
import '../assets/styles/element-variables.scss'

export default {
  install(app) {
    // Element UI gave buttons without a type the el-button--default class, which our button styles build on
    app.use(ElementPlus, { button: { type: 'default' } })

    // Element Plus calendars start the week on the dayjs locale's weekStart (0 = Sunday)
    dayjs.Ls.en.weekStart = browserFirstDayOfWeek() % 7
  },
} as Plugin
